__turbopack_context__.v({
  "body": "egdiMG_body",
  "emptyState": "egdiMG_emptyState",
  "footer": "egdiMG_footer",
  "line": "egdiMG_line",
  "lineActions": "egdiMG_lineActions",
  "lineDetails": "egdiMG_lineDetails",
  "linePrice": "egdiMG_linePrice",
  "lineTitle": "egdiMG_lineTitle",
  "lineVariant": "egdiMG_lineVariant",
  "lines": "egdiMG_lines",
  "qty": "egdiMG_qty",
  "thumb": "egdiMG_thumb",
  "thumbPlaceholder": "egdiMG_thumbPlaceholder",
  "totals": "egdiMG_totals",
  "unavailableNotice": "egdiMG_unavailableNotice",
});
